class Animation {
  element: HTMLElement;
  animationTrigger: string | number;
  animationDelay: number;
  sameElementId: string | null;
  animationType: string;
  delay: number;
  isChildren: boolean;
  childrenElements: HTMLCollection | [];

  /**
   * constructor
   * @param { HTMLElement } element
   */
  constructor(element: HTMLElement) {
    this.element = element;
    this.animationTrigger = this.element.getAttribute('data-animation-trigger') || 'load';
    this.animationDelay = Number(this.element.getAttribute('data-animation-delay')) || 0;
    this.sameElementId = this.element.getAttribute('data-same-element-id');
    this.animationType = this.element.getAttribute('data-animation-type') || 'fadeIn';
    this.animationType = (this.animationType === '') ? 'fadeIn' : this.animationType;
    this.delay = Number(this.element.getAttribute('data-delay')) || 0;
    this.isChildren = this.element.getAttribute('data-children') === 'true';
    this.childrenElements = this.isChildren ? this.element.children : [];
  }

  /**
   * 初期化
   * アニメーションクラスの付与
   * [data-animation-type]が none は何もしない
   */
  init() {
    switch (this.animationType) {
      case 'fadeInUp':
        this.element.classList.add('c-animate-fade-in-up');
        break;
      case 'imgEffect':
        this.element.classList.add('c-animate-img-effect');
        break;
      default:
        break;
    }

    this.setAnimation();
  }

  /**
   * アニメーションの発火
   */
  private setAnimation() {
    if (this.animationTrigger === 'load') {
      /**
       * ロードイベント
       */
      window.addEventListener('load', () => {
        setTimeout(() => {
          this.element.classList.add('is-animate-start');
          this.element.classList.add('is-animate');
        }, this.animationDelay);
      });
    } else {
      /**
       * スクロールイベント
       */
      const header = document.querySelector('.l-header') as HTMLElement;
      const windowH = window.innerHeight;
      const trigger = Number(this.animationTrigger);
      const target = this.element;
      let elementOffsetTop: number;
      let scrollY: number, triggerPoint: number;

      window.addEventListener('scroll', () => {
        if (target.classList.contains('is-animate')) return;
        scrollY = window.scrollY;
        elementOffsetTop = target.getBoundingClientRect().top - header.offsetHeight + scrollY;

        if (trigger === 0) {
          triggerPoint = elementOffsetTop;
        } else {
          triggerPoint = elementOffsetTop - (windowH * (trigger * 0.01));
        }

        if (scrollY > triggerPoint) {
          setTimeout(() => {
            target.classList.add('is-animate-start');
            target.classList.add('is-animate');
          }, this.animationDelay);
        }
      });
    }
  }
}

export default Animation;
